// hooks/useWakeLock.js
import { useCallback, useRef } from "react";

export function useWakeLock() {
    const wakeLockRef = useRef(null);

    const requestWakeLock = useCallback(async () => {
        try {
            if ("wakeLock" in navigator) {
                wakeLockRef.current = await navigator.wakeLock.request("screen");
                console.log("🔒 Wake Lock activado");

                wakeLockRef.current.addEventListener("release", () => {
                    console.log("🔓 Wake Lock liberado automáticamente");
                });
            } else {
                console.warn("Wake Lock API no soportado");
            }
        } catch (err) {
            console.error("Error activando Wake Lock:", err);
        }
    }, []);

    const releaseWakeLock = useCallback(async () => {
        try {
            if (wakeLockRef.current) {
                await wakeLockRef.current.release();
                wakeLockRef.current = null;
                console.log("🔓 Wake Lock liberado manualmente");
            }
        } catch (err) {
            console.error("Error liberando Wake Lock:", err);
        }
    }, []);

    return { requestWakeLock, releaseWakeLock };
}
